
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconComponent, TagComponent, TypographyComponent } from '@hyperkit';

@Component({
    standalone: true,
  imports: [CommonModule, TypographyComponent, IconComponent, TagComponent],
  selector: 'hyperkit-report-query-header',
  templateUrl: './report-query-header.component.html',
  styleUrls: ['./report-query-header.component.scss']
})
export class ReportQueryHeaderComponent {
  @Input() isPivot = false;
  @Input() numPivots = 0;
  @Input() category = '';
  @Input() parentQuery = '';
}